import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Subscription, forkJoin } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { BlogArticleDetail, BlogArticlesPage } from 'src/app/services/rest-api/rest-api';
import { RestApiService } from 'src/app/services/rest-api/rest-api.service';

@Component({
  selector: 'libero-blog-article-detail',
  templateUrl: './blog-article-detail.component.html',
  styleUrls: ['./blog-article-detail.component.scss'],
  standalone: false
})
export class BlogArticleDetailComponent implements OnInit, OnDestroy {

  private articleId?: number;
  public otherPosts: BlogArticleDetail[] = [];
  public articleDetail?: BlogArticleDetail;
  private detailSubscription?: Subscription;
  public errored = false;
  public loading = true;

  public constructor(
    private route: ActivatedRoute,
    private restApiService: RestApiService,
  ) {}

  public ngOnDestroy(): void {
    this.detailSubscription?.unsubscribe();
  }

  public ngOnInit(): void {

    this.detailSubscription = this.route.params.pipe(
      mergeMap((params: Params) => {
        this.articleId = +params['articleId'];
        const requests = [
          this.restApiService.getBlogArticlesPage({ page: 0, size: 10 }),
          this.restApiService.getBlogArticleDetail(this.articleId)
        ];
        return forkJoin(requests)
      })
    )
    .subscribe({
      next: ([otherPosts, articleDetail]) => {
        this.loading = false;
        this.otherPosts = (otherPosts as BlogArticlesPage).content.filter(post => post.blogId !== this.articleId);
        this.articleDetail = articleDetail as BlogArticleDetail;
      },
      error: () => { this.loading = false; this.errored = true; }
    });

  }

}
